import Grid from "@material-ui/core/Grid";
import withStyles from '@material-ui/core/styles/withStyles';
import { withSnackbar } from 'notistack';
import React from 'react';
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CommonReducerAction } from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        marginRight: '10px',
    },
    typography: {
    },
});

class Preview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        // this.GetSubscriptionLeaves =  this.GetSubscriptionLeaves.bind(this)
    }

    render() {
        const { classes } = this.props;
        const language = this.props.Language.attendancepolicy;
        return (
            <IntlProvider locale="en" messages={language}>
                <div>
                    <div className={classes.root}>
                        <Grid container>
                            <Grid item xs={12} md={12} sm={12} >
                            <div>
                                <p className="">Leave name</p>
                                <p className="">{this.props.InitLeavesPolicy.leavename}</p>
                            </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </IntlProvider>
        );
    }
}

const mapStateToProps = (state) => ({
        Language: state.LanguageAction.Language,
        InitLeavesPolicy: state.InitLeavesPolicy,
    });

const mapDispatchToProps = (dispatch) => bindActionCreators({
        ChangeLanguage: (data) => ChangeLanguage(data),
        CommonReducerAction: (data) => CommonReducerAction(data),
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Preview)));
